import { motion } from "framer-motion";

export default function ProjectCard({ project, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -5, backgroundColor: "#141414" }}
      style={{
        background: "var(--bg)",
        padding: "2.2rem",
        position: "relative",
        overflow: "hidden",
        cursor: "default",
        transition: "background 0.3s",
      }}
    >
      {/* Top border reveal on hover */}
      <motion.div
        initial={{ scaleX: 0 }}
        whileHover={{ scaleX: 1 }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 2,
          background: "var(--accent)",
          transformOrigin: "left",
        }}
        transition={{ duration: 0.3 }}
      />

      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: "0.68rem",
          color: "var(--muted)",
          letterSpacing: "0.15em",
          marginBottom: "1.2rem",
        }}
      >
        {project.id}
      </div>

      <h3
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "1.9rem",
          lineHeight: 1,
          marginBottom: "0.8rem",
          color: "var(--text)",
        }}
      >
        {project.title}
      </h3>

      <p
        style={{
          fontSize: "0.88rem",
          color: "#666",
          lineHeight: 1.75,
          marginBottom: "1.4rem",
        }}
      >
        {project.desc}
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", marginBottom: "1.5rem" }}>
        {project.stack.map((s) => (
          <span
            key={s}
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: "0.65rem",
              color: "var(--accent2)",
              border: "1px solid rgba(0,212,255,0.18)",
              padding: "0.2rem 0.5rem",
            }}
          >
            {s}
          </span>
        ))}
      </div>

      <div style={{ display: "flex", gap: "1rem" }}>
        <a href={project.github} target="_blank" rel="noreferrer">
          <motion.span
            whileHover={{ gap: "0.8rem" }}
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: "0.7rem",
              letterSpacing: "0.1em",
              color: "var(--accent)",
              textTransform: "uppercase",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.4rem",
              transition: "gap 0.2s",
            }}
          >
            GitHub →
          </motion.span>
        </a>
        {project.live && (
          <a href={project.live} target="_blank" rel="noreferrer">
            <motion.span
              whileHover={{ color: "var(--text)" }}
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.7rem",
                letterSpacing: "0.1em",
                color: "var(--muted)",
                textTransform: "uppercase",
                display: "inline-flex",
                alignItems: "center",
                gap: "0.4rem",
              }}
            >
              Live ↗
            </motion.span>
          </a>
        )}
      </div>
    </motion.div>
  );
}
